import React, { Component } from 'react';
import { translate } from '../../services';
import { connect } from 'react-redux';
import { flagState, messageDispatcher } from '../../store';
import { PropTypes } from 'prop-types';
import excelExampleImage from '../../../style/images/excel-example.png';
import { CloseIconNew, DeleteIconNew, GreyDeleteIconNew, ImportIconNew, RedCheckMarkIconNew, TrashWhiteIconNew, closePopup } from '../../../style/images';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import classNames from 'classnames';
import { BusyContainer } from '../BusyContainer';

export class ExcelImportComponent extends Component {
  
  constructor( props ) {
    super( props );
    this.state = {
      file:"",
    };
  }

  selectFiles = () => {
    if ( this.fileInput.files.length > 1 ) {
      this.props.addMessage( { timeout: 10000, messageText: translate( 'You can not select more than one file' ), messageType: 'warning' } );
      this.fileInput.value = null;
      return;
    }

    if ( !this.fileInput.files[0].name.endsWith( '.xlsx' ) ) {
      this.props.addMessage( { timeout: 10000, messageText: translate( 'This file type is not supported. Please select an excel file in .xlsx format' ), messageType: 'warning' } );
      this.fileInput.value = null;
      return;
    }
    this.setState({file:this.fileInput.files[0].name})
    this.props.import( this.fileInput.files[0] );
    this.fileInput.value = null;
  }

  upload = async() => {
    this.fileInput && await this.fileInput.click();
  }
  
  removeFile = ()=>{
    this.fileInput.value = null
    this.setState({file:""})
  }
  
  setFileInput = fileInput => this.fileInput = fileInput

  render() {
    const { isBusy } = this.props;

    return <div className="excel-import">
      {!this.props.mobileCartFooter?
      <>
      {/* <h3>{ translate( 'Excel Import' ) }</h3> */}
      <span className='import-description'>{ translate( 'Please use files as exported from configurator to load products into cart.' ) }</span>
      <div className={this.state.file===""?'upload':'uploaded'}>
        <div style={{display:"flex", flexDirection:"column"}}>
          <span className='upload-heading'>{translate( 'Upload product listing' )}</span>
          <span className='upload-description'>{translate( 'Maximum upload size of 10 MB.' )}</span>
        </div>
        <div style={{flexGrow:1}}></div>
          {this.state.file===""?<>
            <div className='file-upload' onClick={this.upload}>
              <span className='choose-file' style={{fontSize:"14px"}}>{translate("choose file")}</span>
              <Box component="img" src={ImportIconNew} sx={{width:"16px", height:"16px"}}></Box>
            </div>
          </>:<>
           <div className='file-uploaded'>
           <span>
              {this.state.file}
           </span>
           {/* <Box component="svg" src={DeleteIconNew} onClick={this.removeFile} sx={{width:"16px", height:"16px", fill:"#696969", color:"#696969"}}></Box> */}
           <img src={GreyDeleteIconNew} onClick={this.removeFile} style={{width:"16px", height:"16px", fill:"#696969", cursor:isBusy?"wait":"pointer"}}></img>
           </div>
            </>}
        <input disabled={ isBusy }  type="file" ref={ this.setFileInput } onClick={ this.upload } onChange={()=>{this.setState({file:this.fileInput?.files[0]?.name})}} accept=".xlsx"/>
      </div>
      {/* <input disabled={ isBusy } type="file" ref={ this.setFileInput } onChange={ this.selectFiles } accept=".xlsx"/> */}
      <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end",width:"100%", alignItems:"center"}}>
          <div className={classNames('primary-button',{"disabled":this.state.file===""?true:false, "isBusy":isBusy })} onClick={ this.selectFiles }>
            {!isBusy?<span>{ translate( 'Import' ) }</span>:
            <BusyContainer isBusy={isBusy} position="relative" top="0px" left="0px" height="100%" size={24}></BusyContainer>}
          </div>
          <div className="tertiary-button" onClick={this.props.onClose}>
                                        <span>{translate("Cancel")}</span>
                                    </div>
      </div>
      
      {/* <img src={ excelExampleImage }/> */}
      </>:<>
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.onClose} width="18px" height="18px" sx={{position:"absolute", top:"12px", right:"12px", height:"20px", width:"20px", borderRadius:"56px"}}>
                            <Box component="img" src={closePopup} sx={{height:"18px", width:"18px"}}></Box>
            </MuiIconButton>
          <div className='mobile-excel-import-header'>
            <span className='header'>{this.state.file===""?translate("Wishlist Importing"):translate("Wishlist imported")}</span>
            <Box component="img" sx={{height:"16px", width:"16px"}} src={RedCheckMarkIconNew} display={this.state.file===""?"none":"flex"}></Box>
          </div>
        <div className='upload'>
        {this.state.file===""?<>
            <div className='file-upload' onClick={this.upload}>
              <Box component="img" src={ImportIconNew} sx={{width:"16px", height:"16px"}}></Box>
              <span className='upload-heading' style={{fontSize:"14px"}}>{translate("Upload product listing")}</span>
            </div>
            <span className='small-text'>{translate( 'XLSX file' )}</span>
          </>:<>
           <div className='file-uploaded'>
           <span className='uploaded-text'>
              {this.state.file}
           </span>
           <Box component="img" src={TrashWhiteIconNew} onClick={this.removeFile} sx={{width:"16px", height:"16px"}}></Box>
           </div>
           <Box sx={{width: "156px", height: "6px", background:"#E12E2E",mt:"16px"}}></Box>
            </>}
            <input disabled={ isBusy }  type="file" ref={ this.setFileInput } onClick={ this.upload } onChange={()=>{this.setState({file:this.fileInput?.files[0]?.name})}} accept=".xlsx"/>
        </div>
        <div className='mobile-import-footer'>
          <Box sx={{display:"flex", alignItems:"flex-start", gap:"8px"}}>
          <div className={classNames('primary-button',{"disabled":this.state.file===""?true:false, "isBusy":this.props.flags.isImporting })} onClick={ this.selectFiles }>
            {!this.props.flags.isImporting?<span>{ translate( 'Import' ) }</span>:
            <BusyContainer isBusy={this.props.flags.isImporting} position="relative" top="0px" left="0px" height="100%" size={24}></BusyContainer>}
          </div>
          <div className="tertiary-button" style={{color:"var(--secondary-colors-data-vis-red-60, #E12E2E)"}} onClick={this.props.onClose}>
                                        <span>{translate("Cancel")}</span>
                                    </div>
          </Box>
        </div>
      </>}
      </div>;
  }
}

ExcelImportComponent.propTypes = {
  addMessage: PropTypes.func.isRequired,
  import: PropTypes.func.isRequired,
  isBusy: PropTypes.bool
};

export const ExcelImport = connect( flagState, messageDispatcher )( ExcelImportComponent );